import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'

export const SearchBarContainer = styled.div({
  backgroundColor: tokens.color.yeezy[0],
  width: '100%',
  zIndex: tokens.zIndex.search,
  display: 'block'
})

export const SearchIconWrapper = styled.button<{ showSearchInput?: boolean }>(
  {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%',
    background: tokens.color.yeezy[0],
    padding: 0,
    color: tokens.color.airJordan.p,
    zIndex: tokens.zIndex.dropdown,
    borderBottom: `${tokens.borderWidth.s} solid transparent`,

    '&:hover': {
      cursor: 'pointer'
    }
  },
  ({ showSearchInput }) =>
    showSearchInput && {
      'svg path': {
        strokeWidth: '0.5px',
        stroke: tokens.color.airJordan[500],
        fill: tokens.color.airJordan[500]
      }
    }
)

export const LoadingContainer = styled.div({
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  background: tokens.color.yeezy.p,
  marginBottom: 0,
  borderBottom: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[100]}`,
  padding: tokens.spacing[5]
})

export const NavbarBackdrop = styled.div({
  top: '100%',
  height: '100vh',
  position: 'absolute',
  left: 0,
  right: 0,
  background: `rgba(20, 21, 22, 0.5)`,
  zIndex: tokens.zIndex.searchBackdrop
})
